import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';
import { SharedModule } from '@shared/shared.module';
import { TeamScorecard } from "@shared/models/team-scorecard";

const teamUrl = `${environment.apiBaseUrl}platform/teams`;

@Injectable({
  providedIn: SharedModule
})
export class TeamService {

  memberListData: any;
  teamsData: any;

  constructor(private http: HttpClient) { }

  list(): Observable<Team.TeamModel[]> {
    return this.http.get<Team.TeamModel[]>(`${teamUrl}`);
  }

  setList(data: any): void {
    this.teamsData = data;
  }

  getStoredList(): any {
    return this.teamsData;
  }

  get(id: string): Observable<Team.TeamModel> {
    return this.http.get<Team.TeamModel>(`${teamUrl}/${id}`);
  }

  create(team: any): Observable<Team.TeamModel> {
    return this.http.post<Team.TeamModel>(`${teamUrl}`, team);
  }

  update(team: any): Observable<Team.TeamModel> {
    return this.http.put<Team.TeamModel>(`${teamUrl}/${team.get('id')}`, team);
  }

  updateTeam(team: any, teamId): Observable<Team.TeamModel> {
    return this.http.put<Team.TeamModel>(`${teamUrl}/${teamId}`, team);
  }

  delete(id: string): Observable<any> {
    return this.http.delete<any>(`${teamUrl}/${id}`);
  }

  initializeTabList(isUpdate?): Observable<TeamScorecard.InitializeStepModel[]> {
    let params = new HttpParams();

    if (isUpdate) {
      params = params.append('isUpdate', isUpdate);
    }
    return this.http.get<TeamScorecard.InitializeStepModel[]>(`${teamUrl}/scorecard/initialize`, { params });
  }

  initializeScorecardTabDetail(teamId: string, addonName: string, scorecardId?: string): Observable<TeamScorecard.TabDetailModel[]> {

    const url = scorecardId
        ? `${teamUrl}/${teamId}/scorecard/${scorecardId}/initialize/${addonName}`
        : `${teamUrl}/${teamId}/scorecard/initialize/${addonName}`;

    return this.http.get<any>(url)
      .pipe(
        map(item => item.tabDetailsItems)
      );
  }

  initializeScorecardCreate(data: TeamScorecard.CreateModel, scorecardId?: string): Observable<TeamScorecard.CreateResponseModel> {
    if (scorecardId) {
      return this.http.put<TeamScorecard.CreateResponseModel>(`${teamUrl}/scorecard/${scorecardId}/initialize`, {...data});
    } else {
      return this.http.post<TeamScorecard.CreateResponseModel>(`${teamUrl}/scorecard/initialize`, {...data});
    }
  }

  scorecardList(): Observable<Base.KeyLabelModel[]> {
    return this.http.get<Base.KeyLabelModel[]>(`${teamUrl}/scorecards`);
  }

  getIncludedandUpperTeams(up, level, filterByLevel, all): Observable<any> {
    let params = new HttpParams();

    params = params.append('up', up);

    params = params.append('level', level);

    params = params.append('filterByLevel', filterByLevel);

    params = params.append('all', all);

    return this.http.get<any[]>(`${teamUrl}`, { params });
  }
  getMemberList(teamId: string): Observable<any> {
    return this.http.get<any>(`${teamUrl}/${teamId}/members`);
  }

  setMemberList(data: any): void {
    this.memberListData = data;
  }

  getStoredMemberList(): any {
    return this.memberListData;
  }
}

